/* @ngInject */
export function RubricPointsController ($scope, $translate) {
	$scope.getPointsAriaIndex = function () {
		const pointsIndex = ($scope.schema?.elements || [])
			.filter((item) => item.type === 'points')
			.indexOf($scope.element);

		return pointsIndex >= 0 ? pointsIndex + 1 : null;
	};

	$scope.getPointsTitleAriaLabel = function () {
		const pointsIndex = $scope.getPointsAriaIndex();
		const label = $scope.element.title || $translate.instant('rubric_aria-points-item-label');
		return pointsIndex != null ? `${label} ${pointsIndex}` : label;
	};

	$scope.getPointsDescriptionAriaLabel = function () {
		const pointsIndex = $scope.getPointsAriaIndex();
		const label = $scope.element.desc || $translate.instant('rubric_aria-points-item-description');
		return pointsIndex != null ? `${label} ${pointsIndex}` : label;
	};

	$scope.getPointsContextLabel = function () {
		const pointsIndex = $scope.getPointsAriaIndex();
		const label = $scope.element.title || $translate.instant('rubric_aria-points-item');
		return pointsIndex != null ? `${label} ${pointsIndex}` : label;
	};

	$scope.getPointsValueAriaLabel = function () {
		return $translate.instant('rubric_aria-points-for', {context: $scope.getPointsContextLabel()});
	};

	$scope.getPointsTotalAriaLabel = function () {
		return $translate.instant('rubric_aria-total-points-for', {context: $scope.getPointsContextLabel()});
	};
}
